import { render, staticRenderFns } from "./StatementDetail.vue?vue&type=template&id=4865b596&scoped=true"
import script from "./StatementDetail.vue?vue&type=script&lang=js"
export * from "./StatementDetail.vue?vue&type=script&lang=js"
import style0 from "./StatementDetail.vue?vue&type=style&index=0&id=4865b596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4865b596",
  null
  
)

export default component.exports